import { ToastOptions } from "@ionic/react";
import { HookOverlayOptions } from "@ionic/react/dist/types/hooks/HookOverlayOptions";

type ToastButton = {
  text: string;
  role?: string;
  handler?: () => void;
};

export const presentToast = (
  present_toast: (options: ToastOptions & HookOverlayOptions) => void,
  message: string,
  color: "success" | "danger" = "danger",
  duration: number = 5000,
  position: "top" | "middle" | "bottom" = "top",
  buttons?: (ToastButton | string)[]
) => {
  present_toast({
    // layout: 'stacked',
    cssClass: "custom-toast",
    message: message,
    duration: duration,
    position: position,
    color: color,
    buttons: buttons,
  });
};

// Calculate the remaining time based on the end time stored in localStorage
export const calculateTimeLeft = (): number => {
  const endTime = localStorage.getItem("resendCodeTimerEndTime");
  if (!endTime) return 300; // Default to 5 minutes if there's no timer set
  const timeLeft = Math.floor((parseInt(endTime) - Date.now()) / 1000);
  return timeLeft > 0 ? timeLeft : 0;
};

export const transformKey = (key: string): string => {
  return key
    .toLowerCase()
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

export const devLog = (...args: any[]) => {
  if (1 || process.env.NODE_ENV === "development") {
    Function.prototype.apply.call(console.log, console, args);
  }
};

export const roleOnly = (roleName: string): string => {
  // Extract just the role name, removing any prefix like "the" or other descriptors
  return roleName.replace(/^(the\s+)?/i, "");
};
